import imageUrlBuilder from "@sanity/image-url";
import { client } from "../client.js";
import { FaPlus } from "react-icons/fa";
import format from "date-fns/format";
import fr from "date-fns/locale/fr";

const builder = imageUrlBuilder(client);
function urlFor(source) {
  return builder.image(source);
}

// iiii do MMMM yyyy

const OneProjet = ({
  titre,
  lien,
  description,
  mainImage,
  dateCreation,
  dateMisAJour,
}) => {
  return (
    <>
      <li className="bg-[#2b3e45] w-full flex flex-col p-3 items-center space-y-3 rounded group">
      <a
          target="_blank"
          rel="noreferrer"
          href={lien}
          className="flex flex-col w-full space-y-3 items-center"
        >
        <div className="overflow-hidden flex justify-center items-center w-full relative transition-all">
          <img
            className="h-72 w-full object-cover lg:h-56 xl:h-64 lg:group-hover:scale-105 transition-all ease-in-out duration-500"
            src={urlFor(mainImage).url()}
            alt="projet"
          />
          <span className="w-0 h-0 rounded bg-[#82aac1] absolute opacity-30 top-0 left-0 ease-out duration-500 transition-all group-hover:w-full group-hover:h-full -z-1"></span>
          <FaPlus className="w-8 h-8 absolute hidden group-hover:block text-[#82aac1]" />
        </div>
        <p className="font-bold text-2xl text-[#c3e88d] ">
        {titre}
        </p>
        <p className="font-bold text-center text-sm text-white">
          {truncatDesc(description)}
        </p>
        {/* <p className="text-xs text-gray-200">{new Date(dateCreation).toLocaleDateString()}</p> */}
        <p className="text-xs text-[#82aac1] text-center">Crée le {format(new Date(dateCreation), 'dd MMMM yyyy', {locale: fr})} - Dernière mise à jour le {format(new Date(dateMisAJour), 'dd MMMM yyyy', {locale: fr})}</p>
        </a>
      </li>
    </>
  );
};

// const truncatTitre = (str) => {
//   // console.log(str.substring(0, 20).length);
//   return str.length > 35 ? `${str.substring(0, 35)}...` : str;
// };

const truncatDesc = (str) => {
  // console.log(str.substring(0, 20).length);
  return str.length > 100 ? `${str.substring(0, 100)}...` : str;
};

export default OneProjet;
